export default __webpack_public_path__ + "static/project-slide-2-768-700-7879a2e584d08485d0d9eb34f807ec80.jpg";